export default {
  title: 'Fooi-instellingen',
  form: {
    has_tips: {
      label: 'Fooi toestaan',
    },
    default_tip_percentage: {
      label: 'Vooraf geselecteerd fooipercentage',
      tooltip: 'Dit is het percentage dat vooraf wordt geselecteerd voor de klant bij het betalingsscherm',
    },
    is_tip_hidden_on_receipt: {
      label: 'Fooi niet zichtbaar op bonnen',
      tooltip: 'Indien ingeschakeld, wordt fooi verborgen op gedrukte bonnen en in het bestellingsinformatievenster',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
